import { useUser, useClerk } from '@clerk/clerk-react'
import { Menu, Avatar, Text, Group, UnstyledButton } from '@mantine/core'
import { IconLogout, IconUser, IconChevronDown } from '@tabler/icons-react'
import { useState, useEffect } from 'react'

export function UserMenu() {
    const { user } = useUser()
    const { signOut } = useClerk()
    const [opened, setOpened] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    // Listen for window resize to update mobile state
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    if (!user) return null

    const handleSignOut = () => {
        signOut()
    }

    return (
        <Menu
            opened={opened}
            onChange={setOpened}
            position="bottom-end"
            width={200}
            shadow="md"
        >
            <Menu.Target>
                <UnstyledButton
                    style={{
                        padding: isMobile ? '4px' : '8px',
                        borderRadius: '8px',
                        border: '1px solid transparent',
                        transition: 'border-color 0.2s',
                        maxWidth: isMobile ? '120px' : 'none',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = 'var(--mantine-color-gray-3)'
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = 'transparent'
                    }}
                >
                    <Group gap="xs">
                        <Avatar
                            src={user.imageUrl}
                            size={isMobile ? "xs" : "sm"}
                            radius="xl"
                            alt={user.fullName || user.primaryEmailAddress?.emailAddress || 'User'}
                        >
                            <IconUser size={isMobile ? 12 : 16} />
                        </Avatar>
                        {!isMobile && (
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Text size="sm" fw={500} truncate>
                                    {user.fullName || user.firstName || 'User'}
                                </Text>
                                <Text size="xs" c="dimmed" truncate>
                                    {user.primaryEmailAddress?.emailAddress}
                                </Text>
                            </div>
                        )}
                        <IconChevronDown size={isMobile ? 12 : 14} />
                    </Group>
                </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>Account</Menu.Label>
                <Menu.Item
                    leftSection={<IconUser size={14} />}
                    onClick={() => {
                        // You can add profile management here later
                        console.log('Profile clicked')
                    }}
                >
                    Profile
                </Menu.Item>

                <Menu.Divider />

                <Menu.Item
                    leftSection={<IconLogout size={14} />}
                    color="red"
                    onClick={handleSignOut}
                >
                    Sign out
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
} 